import { render } from "./RecommendComponent.vue?vue&type=template&id=f42b461e&scoped=true"
import script from "./RecommendComponent.vue?vue&type=script&lang=js"
export * from "./RecommendComponent.vue?vue&type=script&lang=js"

import "./RecommendComponent.vue?vue&type=style&index=0&id=f42b461e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f42b461e"]])

export default __exports__